$(document).on('click', '.toggle-password', function() {
    var $this = $(this).toggleClass('visible');

    $this.parent().find('input')
        .toggleClass('visible')
        .attr('type', $this.hasClass('visible') ? 'text' : 'password')
        .focus();
});